import axios from "axios";

import {IGetPendingBookingsListParams, IPendingBookingsBySegmentAndCategoryList} from "../../pages/dashboard/types";

export const getPendingBookingsBySegmentAndCategory = async (params: IGetPendingBookingsListParams): Promise<IPendingBookingsBySegmentAndCategoryList[]> => {
    const response = await axios.post('/booking/dashboard/bySegments', params);
    return response.data;
};
